module.exports = __webpack_public_path__ + "img/bg-jorge-ortiz-fuentes.b9d6e121.jpg";